// extracted by mini-css-extract-plugin
export default {"signup__links":"Signup_signup__links__Cauha AuthPage_auth__links__ws-cL","signup":"Signup_signup__coCzs"};